module.exports = __webpack_public_path__ + "static/media/my-way.4aaf2655.png";